module.exports = __webpack_public_path__ + "img/arqui-amb.e1915bb5.png";